import { ReactNode } from 'react'

import { AllFeatureIds } from 'generated/featureIds.generated'
import { FeatureWallDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

export const FeatureWall: React.FC<{
  featureName: AllFeatureIds
  children: ReactNode
  showWhenEnabled?: boolean
}> = ({ featureName, children, showWhenEnabled = true }) => {
  const { company } = useCurrentSession()
  const { data } = useQuery(FeatureWallDocument, {
    variables: {
      companyId: company.id,
      featureName: featureName,
    },
  })

  const hasFeature = (data?.features?.features?.length || 0) > 0
  const shouldRender = showWhenEnabled == hasFeature

  if (shouldRender) {
    return <>{children}</>
  } else {
    return <></>
  }
}
